import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let AreaCodePanel = class AreaCodePanel extends Vue {
    constructor() {
        super(...arguments);
        this.areaCode = [];
        this.areaCodeSearch = [];
        this.searchPanel = false;
    }
    async created() {
        let r = await this.$axios.get('/api/core/user/member/getAreaCodeList');
        this.areaCode = r.data;
    }
    goAnchor(selector, letter) {
        let anchor = document.querySelector(selector);
        if (anchor) {
            anchor.scrollIntoView();
            this.$Toast({
                message: letter,
                className: 'letter-zindex',
                duration: 800,
            });
        }
    }
    onSearch(val) {
        this.searchPanel = !!val;
        this.areaCodeSearch = val ? getSearchResult(this.areaCode, val) : [];
    }
    setArea(item) {
        this.$emit('on-close', item);
    }
};
tslib_1.__decorate([
    Prop()
], AreaCodePanel.prototype, "show", void 0);
AreaCodePanel = tslib_1.__decorate([
    Component({})
], AreaCodePanel);
export default AreaCodePanel;
function getSearchResult(catList, needle) {
    // 区号分了类别，在每个类别里面找到匹配的区号
    return catList
        .map(cat => ({
        ...cat,
        area_code_list: cat.area_code_list.filter(area => area.area_name.includes(needle) || area.area_code.includes(needle)),
    }))
        .filter(cat => cat.area_code_list.length);
}
